module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_682.836a2eac.jpg";